<template>
  <CRow>
    <CCol col="12" md="12" style="margin-top: 10px">
      <CCard>
        <CCardHeader>
          <CRow>
    <CCol col="4">  <h5 style="margin-top: 7px;font-size:x-large"> Please choose token</h5>
    </CCol>
     <CCol col="4">
    </CCol>
     <CCol col="4"> <CSelect
            horizontal
            :options="options"
            placeholder="Please select"
            v-model="fielterdata"
            @change="onChange($event)"
            style="
              width: 300px;
              float: right;
              margin-left: 50px;
              margin-top: 6px;
            "
        />
    </CCol>
          </CRow>
       
        
         </CCardHeader>
        <CCardBody v-if="dataentered">
          <CRow>
            <CCol col="12">
              <!-- <h5>check</h5> -->
              <span style="color: red">Please upload .CSV file</span><br />
              <input
                id="fileInput"
                type="file"
                @change="upload"
                accept=".csv"
                ref="input"
              />
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../App.vue";
import Papa from "papaparse";
import { Vselect } from "@/components";
import firebase from "firebase";
const db = firebase.firestore();

export default {
  components: {
    Vselect,
  },
  data() {
    return {
      value: null,
      options: [],
      fielterdata: "please Select",
      dataentered: false,
      grapdata: "",
      tableData: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      tableData5: [],
      cmprArry: "",
      cmprArry2: "",
    };
  },
  methods: {
    assignscaptureData(doc) {
      let smallDocument = {
        id: doc.id,
        isWhiteList: doc.data().isWhiteList,
      };
      return smallDocument;
    },
    upload(e) {
      // console.log("entered");
      const that = this;
      let fname = event.target.files[0].name.split(".");
      if (fname[1].toLowerCase() == "csv") {
        const fileToLoad = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (fileLoadedEvent) => {
          Papa.parse(fileLoadedEvent.target.result, {
            header: true,
            complete(results) {
              // console.log("complete", results);
              // console.log("cmprArry1", that.tableData3);
              for (let i = 0; i < results.data.length; i++) {
                that.tableData2.push(results.data[i]);
              }
              for (let i = 0; i < that.tableData2.length - 1; i++) {
                that.cmprArry2 = that.tableData2[i];
                db.collection("users")
                  .where("ethAddress", "==",that.tableData2[i].address)
                  .get()
                  .then((snapShot) => {
                    snapShot.forEach((doc) => {
                    if (!doc.length > 0) {
                      // console.log("docs[0]",doc.data())
                      let stakeLimit = doc.data().stakeLimit;
                      if (stakeLimit) {
                        let lable = that.grapdata;
                        let value = that.tableData2[i].stakeLimit;
                        let data = stakeLimit;
                        data[lable] = parseInt(value);
                        // console.log("data[lable]",data[lable])
                        db.collection("users")
                          .doc(doc.id)
                          .update({'stakeLimit':data});
                      } else {
                        let lable = that.grapdata;
                        let value = that.tableData2[i].stakeLimit;
                        let data = {
                          stakeLimit: {},
                        };
                        data["stakeLimit"][lable] = parseInt(value);
                        db.collection("users")
                          .doc(doc.id)
                          .update(data);
                      }
                    }
                    })
                  });

                that.tableData4.push(that.cmprArry2.address);
                that.tableData5.push(that.cmprArry2.stakeLimit);
             
             }
              // console.log(" this.tableData5", that.tableData5);
              // console.log("dsata0", that.tableData4);

              let str = [];
              for (let i = 0; i < that.tableData4.length; i++) {
                // console.log("dataentered");

                str.push(that.tableData3.indexOf(that.tableData4[i]) != -1);
              }

              if (!str.includes(false)) {
                // console.log("strdata", !str.includes(false));
                 Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Stakelimit added successfully",
                  showConfirmButton: false,
                  timer: 3000,
                });
                  this.$router.push({
        path: "/stakingCoin",
      });
                // this.$router.push({ name: "stakingCoin" });
              //  location.reload();
              } else {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: "Whitelist is address not matched",
                  showConfirmButton: false,
                  timer: 3000,
                });
                 location.reload();
              }
            },
            error(errors) {
              // console.log("error", errors);
            },
          });
        };
        reader.readAsText(fileToLoad);
      } else {
        document.getElementById("fileInput").value = "";
      }
    },
    coinUpdate() {
      db.collection("users")
        // .where('ethAddress', "==", this.grapdata)
        // .doc(this.id)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            // console.log("dataen", doc.data().ethAddress);
            // for(let i=0;i<this.tableData4.length;i++){
            //   console.log("tableData4",doc.data().ethAddress == this.tableData4[i])
            // }
          });
        });
    },
    assignsmallData(doc) {
      let smallDocument = {
        id: doc.id,
        name: doc.data().name,
        symbol: doc.data().symbol,
        totalSupply: doc.data().totalSupply,
        companyName: doc.data().companyName,
        description: doc.data().description,
        country: doc.data().country,
        ethereum: doc.data().ethAddress,
        contract: doc.data().conAddress,
        location: doc.data().location,
        logo: doc.data().logo,
      };
      return smallDocument;
    },
    gettokens() {
      this.tableData = [];
      const db = firebase.firestore();
      db.collection("companyDetails")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableData.push(this.assignsmallData(doc));

            let value = this.tableData.map((n) => {
              return n.name;
            });

            this.options = value;
          });
          this.loading = false;
        });
    },
    onChange(event) {
      this.grapdata = event.target.value;
      // console.log("grapdata", this.grapdata);
      const db = firebase.firestore();
      db.collection("companyDetails")
        .where("name", "==", this.grapdata)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            // console.log("dataen", doc);
            if (doc.data().isWhiteList == false) {
              Swal.fire({
                position: "center",
                icon: "error",
                title: "Whitelist is not enabled for this token",
                showConfirmButton: false,
                timer: 2000,
              });
              this.dataentered = false;
            } else {
              this.dataentered = true;
              this.cmprArry = doc.data().whiteList;
              for (let i = 0; i < this.cmprArry.length; i++) {
                this.tableData3.push(this.cmprArry[i].address);
              }

              //   console.log("cmprArry2", this.cmprArry2);
            }
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.gettokens();
  },
};
</script>
